

import { createApiCall } from 'services'
import { ActionCallback } from 'store/model'
import { storage, getErrorMessage } from 'utils'

import type { GetProfileResponse, GetRolesResponse, InviteMemberPayload } from './types'

import { fork, takeLatest, call, put } from 'redux-saga/effects'

import { ActionType } from './types'

// The legacy sign-in sagas (GET_OTP_CODE -> /auth/admin/login, RESEND_OTP_CODE -> /resend,
// LOGIN_USER -> /verify, GOOGLE_LOGIN_REQUEST -> /sso-login) were removed on 2026-10-10 with
// those API routes. Nothing dispatched them; sign-in goes through WorkOS AuthKit
// (services/workos-auth.service.ts).

function* getUserProfileSaga() {
  yield takeLatest(ActionType.GET_PROFILE, function* () {
    try {
      const response: GetProfileResponse = yield call(createApiCall, {
        method: 'GET',
        url: '/auth/admin/profile',
      })

      const { data, status } = response

      if (status === 200) {
        yield put({
          type: ActionType.SET_PROFILE,
          payload: data,
        })
      }
    } catch (error) {
      console.error(error)
    }
  })
}

function* checkAuthSaga() {
  yield takeLatest(ActionType.CHECK_AUTH, function* (action: ActionCallback) {
    const { callback } = action
    try {
      // Perform your logic to check authentication, e.g., by checking tokens in localStorage
      const accessToken = storage.getItem('accessToken')
      const refreshToken = storage.getItem('refreshToken')

      if (accessToken && refreshToken) {
        // If authenticated, set the authentication state
        yield put({ type: ActionType.SET_AUTH, payload: true })
        yield put({ type: ActionType.GET_PROFILE })
        yield put({ type: ActionType.GET_ROLES })
      } else {
        // If not authenticated, set the authentication state to false
        yield put({ type: ActionType.SET_AUTH, payload: false })
      }

      if (callback) callback()
    } catch (error) {
      console.error(error)
    }
  })
}

function* getRolesSaga(): Generator {
  yield takeLatest(ActionType.GET_ROLES, function* (action: ActionCallback) {
    try {
      const { callback } = action

      const response: GetRolesResponse = yield call(createApiCall, {
        method: 'GET',
        url: '/roles/admin/supervised',
      })

      const { data, status } = response

      if (status === 200) {
        yield put({
          type: ActionType.SET_ROLES,
          payload: data,
        })
      }

      if (callback) {
        callback({ success: true, content: data })
      }
    } catch (error) {
      console.error(error)
      if (action.callback) {
        action.callback({ success: false, content: getErrorMessage(error) })
      }
    }
  })
}

function* inviteMemberSaga(): Generator {
  yield takeLatest(ActionType.INVITE_MEMBER, function* (action: ActionCallback<InviteMemberPayload>) {
    try {
      const { payload, callback } = action
      const { role_name, ...rest } = payload

      const response: GetRolesResponse = yield call(createApiCall, {
        method: 'POST',
        url: `/invite/admin/${role_name}`,
        data: rest,
      })

      const { data, status } = response

      if (callback) {
        callback({ success: true, content: data })
      }
    } catch (error) {
      console.error(error)
      if (action.callback) {
        action.callback({ success: false, content: getErrorMessage(error) })
      }
    }
  })
}

export default [
  fork(getUserProfileSaga),
  fork(checkAuthSaga),
  fork(getRolesSaga),
  fork(inviteMemberSaga),
]
